import { useEffect, useState } from "react";
import firebase from "../firebase";
import DB_PATH from "../DB_PATH";
import { Plan } from "../../types/Plan";

export default ({ communityId }): Plan[] => {
  const [authors, setAuthors] = useState<Plan[]>([]);
  const db = firebase.firestore();
  const authorRef = db
    .collection(DB_PATH.COMMUNITY)
    .doc(communityId)
    .collection(DB_PATH.PLAN_CATEGORIES);

  useEffect(() => {
    if (!communityId) return;
    const fetchAuthors = async () => {
      try {
        const snapshot = await authorRef.get();
        const fetchedAuthors: Plan[] = [];
        snapshot.forEach((doc) => {
          fetchedAuthors.push({ id: doc.id, ...doc.data() } as Plan);
        });
        setAuthors(fetchedAuthors);
      } catch (error) {
        console.error("Error fetching authors:", error);
      }
    };

    fetchAuthors();

    return () => {};
  }, [communityId]);

  return authors;
};
